export const consolejobApi = {
  queryConsoleJob: '/clouddm/console/api/v1/consolejob/queryconsolejob',
  listConsoleJob: '/clouddm/console/api/v1/consolejob/list',
  retryConsoleTask: '/clouddm/console/api/v1/consolejob/retrytask',
  skipConsoleTask: '/clouddm/console/api/v1/consolejob/skiptask',
  cancelConsoleJob: '/clouddm/console/api/v1/consolejob/cancel',
  listLastFiveFailedJob: '/clouddm/console/api/v1/consolejob/listlastfivefailedjob'
};
